(function () {
  const images = require.context('../images', true);
  const markerIconUrl = images('./icon-marker.svg');

  const shopMap = document.querySelector('.js-shop-map');
  const shopsMap = document.querySelector('.js-shops-map');

  // 座標は手動調整済みの店舗にだけ出力される。無ければ従来どおり住所から取得する
  function readCoordinates(element) {
    const lat = parseFloat(element.dataset.latitude);
    const lng = parseFloat(element.dataset.longitude);

    if (isNaN(lat) || isNaN(lng)) return null;

    return new google.maps.LatLng(lat, lng);
  }

  if(shopMap){
    function renderMap(location) {
      const map = new google.maps.Map(shopMap, {
        center: location,
        zoom: 15
      });

      new google.maps.Marker({
        position: location,
        map,
        title: shopMap.dataset.title,
        icon: {
          url: markerIconUrl,
          scaledSize: new google.maps.Size(21, 28),
        },
      });
    }

    async function initMap() {
      const coordinates = readCoordinates(shopMap);

      if (coordinates) {
        renderMap(coordinates);
        return;
      }

      const geocoder = new google.maps.Geocoder();
      const address = `日本 ${shopMap.dataset.prefecture}${shopMap.dataset.city}${shopMap.dataset.town}`.trim();

      try {
        const response = await geocoder.geocode({
          address: address,
          region: 'jp'
        });

        if (response.results[0]) {
          renderMap(response.results[0].geometry.location);
        }
      } catch (error) {
        console.error('Geocoding failed:', error);
      }
    }
    window.initMap = initMap;
  }


  if(shopsMap){
    async function initMap() {
      const geocoder = new google.maps.Geocoder();
      const map = new google.maps.Map(shopsMap, {
        zoom: 15,
        center: { lat: 38.0, lng: 137.0 }
      });

      const bounds = new google.maps.LatLngBounds();
      const shops = document.querySelectorAll(".js-shop");

      function addMarker(shop, location) {
        const marker = new google.maps.Marker({
          position: location,
          map: map,
          title: shop.querySelector('.name').textContent,
          icon: {
            url: markerIconUrl,
            scaledSize: new google.maps.Size(21, 28),
          }
        });

        let shopElement = shop.cloneNode(true);
        shopElement.querySelector('.link').classList.add('p-map-shop');
        let shopContent = shopElement.innerHTML;

        marker.addListener("click", () => {
          const infoWindow = new google.maps.InfoWindow({
            content: shopContent
          });
          infoWindow.open(map, marker);
        });

        bounds.extend(location);
      }

      for (const shop of shops) {
        const coordinates = readCoordinates(shop);

        if (coordinates) {
          addMarker(shop, coordinates);
          continue;
        }

        const address = `日本 ${shop.dataset.prefecture}${shop.dataset.city}${shop.dataset.town}`.trim();

        try {
          const response = await geocoder.geocode({
            address: address,
            region: 'jp'
          });

          if (response.results[0]) {
            addMarker(shop, response.results[0].geometry.location);
          }
        } catch (error) {
          console.error('Geocoding failed:', address, error);
        }
      }

      if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
        if (map.getZoom() > 15) map.setZoom(15);
      }
    }

    window.initMap = initMap;
  }

}());
